// extracted by mini-css-extract-plugin
export default {"wrapper":"f2-z","play":"g2-z"};